<template>
  <div>
    <a-modal :visible="visible" title="正在过滤中..." :footer="null" :maskClosable="false" :closable="false">
      <a-alert v-if="filterOk==false" message="请不要关闭浏览器，正在过滤中，这可能需要2~3分钟的时间" banner />
      <a-alert v-if="filterOk==true" message="请不要关闭浏览器，过滤完毕，正在加载数据，请稍等" type="success" show-icon />
      <br>
      <a-progress :percent="rootPercent" />
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      filterOk: false,
      rootPercent: this.percent,
      timer: null,
    }
  },

  props: {
    percent: {
      type: Number,
      default: 0,
    }
  },

  watch: {
    rootPercent(newVal, oldVal) {
      if (newVal >= 96) {
        clearInterval(this.timer)
        this.timer = null
        console.log('watch=', newVal)
        console.log('timer=', this.timer)
        this.filterOk = true
      }
    }
  },

  methods: {
    show() {
      this.visible = true
      this.timer = setInterval(() => {
        if (this.rootPercent < 96) {
          this.rootPercent += this.getRandomInt(1, 5)
        }
      }, 2000)
    },

    // 当调用hide()时，说明要进行的操作已经执行完毕，所以手动将进度条置为100
    hide() {
      clearInterval(this.timer)
      this.timer = null
      this.rootPercent = 100
      console.log('在hide里面清除定时器=', this.timer)
      this.visible = false
      // 重置
      this.filterOk = false
      this.rootPercent = 0
    },

    // 生成随机数
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
      // 用法：getRandomInt(1, 5)
    }

  }
}
</script>

<style></style>